import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconHome = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 25 25"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M3.753 14.207v9.108h6v-6.624c0-.915.671-1.656 1.5-1.656h1.5c.828 0 1.5.741 1.5 1.656v6.624h6v-9.108M.753 12.55L10.942 1.3c.281-.31.663-.485 1.06-.485.399 0 .78.175 1.062.486l10.189 11.25",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconHome.displayName = "IconHome";

export { IconHome };
